import React, { useState, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DateTime } from 'luxon';

import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import MoreVertIcon from '@material-ui/icons/MoreVert';

import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    commentContainer: {
        paddingTop: theme.spacing(2)
    },
    commentFlex: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    commentColOne: {
        flexGrow: 0,
        minWidth: 60
    },
    commentColTwo: {
        flexGrow: 1
    },
    commentColThree: {
        flexGrow: 0,
        minWidth: 60,
        textAlign: 'right'
    }
}));

export default function Comment(props) {

    const { app } = useApp();
    const api = useApi();

    const classes = useStyles();

    const { comment, onDelete, onDeleted } = props;

    const [ settingsAnchorEl, setSettingsAnchorEl] = useState(null);

    const handleSettingsOpen = e => {
        setSettingsAnchorEl(e.currentTarget);
    };

    const handleSettingsClose = () => {
        setSettingsAnchorEl(null);
    };

    const commentSettingsId = useMemo(() => {
        return "comment-settings-" + comment.id;
    }, [comment]);

    const deleteComment = () => {
        onDelete();
        api.delete('/comment/' + comment.id ).then(onDeleted);
    };

    return (
        <div className={classes.commentContainer}>
            <div className={classes.commentFlex}>
                <div className={classes.commentColOne}>
                    <Avatar
                        aria-label={comment.user.full_name}
                        alt={comment.user.full_name}
                        className={classes.avatar}
                        src={comment.user.avatar ? comment.user.avatar.full_url : null}
                        >
                        {comment.user.initials}
                    </Avatar>
                </div>
                <div className={classes.commentColTwo}>
                    <Typography variant='subtitle2'>
                        {comment.user.full_name}
                    </Typography>
                    <Typography className={classes.message} variant='subtitle2' color="textSecondary">
                        {DateTime.fromISO(comment.created_at).toRelative()}
                    </Typography>
                </div>
                <div className={classes.commentColThree}>
                    <IconButton
                        onClick={handleSettingsOpen}
                        aria-controls={commentSettingsId}
                        aria-haspopup="true"
                        >
                        <MoreVertIcon size="small"/>
                    </IconButton>
                </div>
            </div>
            <div className={classes.commentFlex}>
                <div className={classes.commentColOne}/>
                <div className={classes.commentColTwo}>
                    <Typography variant="body1" component="p">
                        {comment.message}
                    </Typography>
                </div>
                <div className={classes.commentColThree}/>
            </div>
            <Menu
                id={commentSettingsId}
                anchorEl={settingsAnchorEl}
                keepMounted
                open={Boolean(settingsAnchorEl)}
                onClose={handleSettingsClose}
                >
                {(comment.user_id == app.user.id) &&
                    <MenuItem onClick={deleteComment}>Delete Comment</MenuItem>
                }
                <MenuItem>Tag as Inappropriate</MenuItem>
            </Menu>
        </div>
    )
}
